import { put, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  roundFinishedSuccessAction,
  changeGameStatusAction,
  changeGameStateAction,
  changeTimeLeftAction,
  clearCardsToStoreAction,
} from 'data/reducers';
import { RoundFinishedResponse, Notifications, TableStates } from 'types';
import { gameStatus } from 'constants/common';
import { setJackpotWon, setStageJackpot } from 'data/reducers/AuthReducer';
import { getGameData } from 'core/selectors';
import { GameType } from 'types/tables';

export function* roundFinished(data: RoundFinishedResponse) {
  try {
    if (data.type === Notifications.ROUND_FINISHED) {
      const { game_type } = yield select(getGameData);
      yield put(setJackpotWon(false));
      yield put(setStageJackpot(false));

      yield put(changeGameStateAction({ tableState: TableStates.RoundFinished }));
      yield put(changeTimeLeftAction({ timerLeft: undefined }));
      yield put(changeGameStatusAction({ status: gameStatus.OpenRound }));
      yield put(roundFinishedSuccessAction());

      if (game_type === GameType.CLASSIC_BAC) {
        yield put(clearCardsToStoreAction());
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
